import { AuthError } from './auth-error';

export class AccountDisabledError extends AuthError {
  
}